import React from 'react'
import StyledSmText from '../../common/components/styledSmText/StyledSmText'
import StyledXlText from '../../common/components/styledXlText/StyledXlText'
import StyledMdText from '../../common/components/styledMdText/StyledMdText'

const JoinNetworkCard = ({ data, index }) => {
    return (
        <div className='flex flex-col p-5 gap-14 bg-dull-black'>
            <div>
                <StyledSmText fontColor="text-gray">{data.tagline}</StyledSmText>
            </div>
            <div className='flex flex-col gap-3'>
                <div>
                    <StyledXlText fontColor="text-gradient">{data.heading}</StyledXlText>
                </div>
                <div>
                    <StyledMdText fontColor="text-white">{data.desc}</StyledMdText>
                </div>
            </div>
            <div>
                <img src={data.icon} alt={`Square#${index}`} />
            </div>
        </div>
    )
}

export default JoinNetworkCard
